import React from 'react';
import { Link } from 'react-router-dom';
import MobileSidebar from './sidebar';

export const Header = () => {
  return (
    <header className="header sticky top-0 z-20 w-full  ">
      <div className="container relative flex !w-full justify-between !pb-[17px] !pt-[15px]">
        <div className="flex items-center gap-[15px]">
          <Link
            to={'/'}
            className="logo nav-logo-title border-r border-[#044047] !pr-[15px] !text-[#012E33]"
          >
            <img src="/images/icons/grad-img.svg" alt="grad" />
            IAMAI
          </Link>
          <span className="text-[22px] font-medium leading-[145.45%] tracking-[-0.22px] text-[#044047]">
            Find Tutors
          </span>
        </div>

        <div className="nav-button">
          <Link
            to={'/login'}
            className="fredokaOne h-12 rounded-2xl border border-[#66CDCC] px-6 py-2 text-[#66CDCC]"
          >
            Login
          </Link>
          <MobileSidebar color="header-green" />
        </div>
      </div>
    </header>
  );
};
